const typographyModelEquipService = {
  true: 'Registrar Nuevo Servicio',
  false: 'Editar Servicio',
  warningTitle: 'Servicio Desactivado para Este Tipo de Equipo',
  warningText: 'Este servicio ya no está vinculado a este tipo de equipo. Sin embargo, el historial sigue disponible en los equipos vinculados. Para consultarlo, acceda al equipo deseado.',
};

export default typographyModelEquipService;
